import {
  getOperatorListById,
  getPersonAccountUserid,
  querytradeDetailList,
  syncTradeDetail,
  updateTradeDetail,
} from '../services';

export default {
  namespace: 'consumptionRecordsManage',
  state: {},
  effects: {
    /**
     * 交易明细查询
     */
    *querytradeDetailList({ payload }, { call }) {
      const result = yield call(querytradeDetailList, payload);
      return result;
    },

    /**
     * 获取当前登录的账户
     */
    *getPersonAccountUserid({ payload }, { call }) {
      const result = yield call(getPersonAccountUserid, payload);
      return result;
    },

    /**
     * 同步交易明细
     */
    *syncTradeDetail({ payload }, { call }) {
      const result = yield call(syncTradeDetail, payload);
      return result;
    },

    /**
     * 根据用户id获取账户
     */
    *getOperatorListById({ payload }, { call }) {
      const result = yield call(getOperatorListById, payload);
      return result;
    },

    /**
     * 更新消费明细
     */
    *updateTradeDetail({ payload }, { call }) {
      const result = yield call(updateTradeDetail, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
